export const headerCopy = {
  description: '',
  title: 'Advanced search',
};
